import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bom-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit, OnDestroy {
  private routerEventSub: Subscription;

  shouldShowDefaultContact = true;

  constructor(private router: Router) {}

  ngOnInit() {
    this.routerEventSub = this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        // Show default contact BOM if we are not in a module that uses the 'contact' router outlet
        this.shouldShowDefaultContact = !(<NavigationEnd>e).url.startsWith('/projekter');
      }
    });
  }

  ngOnDestroy() {
    if (this.routerEventSub) {
      this.routerEventSub.unsubscribe();
    }
  }
}
